'use strict';

$(document).ready(function () {
    $(document).on('click', '.crc-submitCta', function () {
        const email = $('input[name="email"]').val();
        $('#crc-widget').addClass('d-none');
        $('.contact-us-success').removeClass('d-none');

        // Scroll up smoothly
        const $container = $('.contact-us-container');
        if ($container.length) {
            const targetOffset = $container.offset().top;
            const headerHeight = $('.header-wrapper').height() + 50;

            const scrollTo = targetOffset - headerHeight;

            $('html, body').animate(
                {
                    scrollTop: scrollTo,
                },
                500
            );
        }

        // GTM event
        window.dataLayer.push({
            event: 'contact_requested',
            user_email: email,
        });
    });
});
